import React, { useCallback, useEffect, useState } from 'react';

import {
  Badge,
  Checkbox,
  FormControlLabel,
  FormGroup,
  IconButton,
  List,
  ListItem,
  Popover,
} from '@material-ui/core';
import { ServicesIcon } from 'components/Icons';

import useStyle from './style';

export default function Configurar() {
  const classes = useStyle();
  const [anchorEl, setAnchor] = useState<any>(null);
  const [hideBadge, setHideBadge] = useState<any>();
  const [checked, setChecked] = useState<boolean>();

  const localNotify: any = localStorage.getItem('notificacaoChat');
  const localBadgeConfig: any = localStorage.getItem('badgeConfig');
  const parseNotify: any = JSON.parse(localNotify);
  const parseBadgeConfig: any = JSON.parse(localBadgeConfig);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchor(event.currentTarget);
    setHideBadge(true);
    localStorage.setItem(
      'badgeConfig',
      JSON.stringify({
        hideBadge: true,
      })
    );
  };

  const handleClose = () => {
    setAnchor(null);
  };

  const handleChange = useCallback(
    (event: any) => {
      setChecked(event.target.checked);
      localStorage.setItem(
        'notificacaoChat',
        JSON.stringify({
          somenteMinhasNotificacoes: event.target.checked,
        })
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [checked]
  );

  useEffect(() => {
    setHideBadge(false);
  }, []);

  useEffect(() => {
    setChecked(parseNotify?.somenteMinhasNotificacoes);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checked]);

  return (
    <React.Fragment>
      <IconButton
        color='primary'
        className={classes.button}
        onClick={handleClick}
      >
        <Badge
          invisible={hideBadge || parseBadgeConfig?.hideBadge}
          variant='dot'
          color='error'
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          overlap='rectangular'
        >
          <ServicesIcon />
        </Badge>
      </IconButton>
      <Popover
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          className: classes.card,
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <List className={classes.list}>
          <ListItem role={undefined} className={classes.item} button>
            <FormGroup>
              <FormControlLabel
                control={<Checkbox checked={checked} onClick={handleChange} />}
                label='Ativar somente minhas notificações'
              />
            </FormGroup>
          </ListItem>
        </List>
      </Popover>
    </React.Fragment>
  );
}
